import React, {useState} from "react";
import "../App.css";

import img1 from "../static/site/1.png";
import img2 from "../static/site/2.png";
import img3 from "../static/site/3.png";
import img4 from "../static/site/4.png";
import img5 from "../static/site/5.png";
import img6 from "../static/site/6.png";
import img7 from "../static/site/7.png";
import img8 from "../static/site/8.png";
import img9 from "../static/site/9.png";
import img10 from "../static/site/10.png";
import img11 from "../static/site/11.png";

import imgCrm1 from "../static/crm/1.png";
import imgCrm2 from "../static/crm/2.png";
import imgCrm3 from "../static/crm/3.png";
import imgCrm4 from "../static/crm/4.png";
import imgCrm5 from "../static/crm/5.png";
import imgCrm6 from "../static/crm/6.png";
import imgCrm7 from "../static/crm/7.png";

import "../styles/site.css";

type SlideKey =
    | "main"
    | "schedule"
    | "lk"
    | "design"
    | "calculator"
    | "orders-view"
    | "order-details"
    | "payment"
    | "labels"
    | "companies"
    | "booking"
    | "feedback"
    | "orders"
    | "supplies"
    | "discounts"
    | "news"
    | "documents"
    | "notifications"
    | "service-users";

interface Slide {
    id: number;
    key: SlideKey;
    title: string;
    image: string;
}

interface Feature {
    key: SlideKey;
    label: string;
}

const slidesSite: Slide[] = [
    {
        id: 1,
        key: "main",
        title: "Привлекающая главная страница",
        image: img1,
    },
    {
        id: 2,
        key: "schedule",
        title: "Расписание поставок",
        image: img2,
    },
    {
        id: 3,
        key: "lk",
        title: "Личный кабинет клиента",
        image: img3,
    },
    {
        id: 4,
        key: "design",
        title: "Индивидуальный дизайн",
        image: img4,
    },
    {
        id: 5,
        key: "calculator",
        title: "Калькулятор стоимости",
        image: img5,
    },
    {
        id: 6,
        key: "orders-view",
        title: "Удобное отображение заказов",
        image: img6,
    },
    {
        id: 7,
        key: "order-details",
        title: "Просмотр и редактирование заказов",
        image: img7,
    },
    {
        id: 8,
        key: "payment",
        title: "Онлайн-оплата",
        image: img8,
    },
    {
        id: 9,
        key: "labels",
        title: "Скачивание этикеток для коробов",
        image: img9,
    },
    {
        id: 10,
        key: "companies",
        title: "Добавление компаний",
        image: img10,
    },
    {
        id: 11,
        key: "booking",
        title: "Запись на поставки",
        image: img11,
    },
];

const slidesCrm: Slide[] = [
    {
        id: 1,
        key: "orders",
        title: "Управление заказами",
        image: imgCrm1,
    },
    {
        id: 2,
        key: "supplies",
        title: "Управление поставками",
        image: imgCrm2,
    },
    {
        id: 3,
        key: "discounts",
        title: "Управление персональными скидками",
        image: imgCrm3,
    },
    {
        id: 4,
        key: "news",
        title: "Управление новостями",
        image: imgCrm4,
    },
    {
        id: 5,
        key: "documents",
        title: "Управление документами",
        image: imgCrm5,
    },
    {
        id: 6,
        key: "notifications",
        title: "Управление уведомлениями",
        image: imgCrm6,
    },
    {
        id: 7,
        key: "service-users",
        title: "Управление сервисными пользователями",
        image: imgCrm7,
    },
];

const featuresSite: Feature[] = [
    {key: "main", label: "Привлекающая главная страница"},
    {key: "schedule", label: "Расписание поставок"},
    {key: "lk", label: "Личный кабинет клиента"},
    {key: "design", label: "Индивидуальный дизайн"},
    {key: "calculator", label: "Калькулятор стоимости заказов"},
    {key: "orders-view", label: "Удобное отображение заказов"},
    {key: "order-details", label: "Просмотр и редактирование заказов"},
    {key: "payment", label: "Онлайн-оплата"},
    {key: "labels", label: "Скачивание этикеток для коробов"},
    {key: "companies", label: "Добавление компаний"},
    {key: "booking", label: "Запись на поставки"},
];

const featuresCrm: Feature[] = [
    { key: "orders", label: "Управление заказами" },
    { key: "supplies", label: "Управление поставками" },
    { key: "discounts", label: "Управление персональными скидками" },
    { key: "news", label: "Управление новостями" },
    { key: "documents", label: "Управление документами" },
    { key: "notifications", label: "Управление уведомлениями" },
    { key: "service-users", label: "Управление сервисными пользователями" },
];

type FaqItem = {
    id: string;
    q: string;
    a: string;
};


const faqItems: FaqItem[] = [
    {
        id: "price",
        q: "Сколько стоит сайт для фулфилмента?",
        a: "Стоимость зависит от выбранного пакета. При этом пакет можно расширять: добавим нужные функции (онлайн-оплату, этикетки, калькулятор и т.д.). На консультации за 15–20 минут подберём оптимальный пакет под ваши процессы и сразу скажем итоговую стоимость и сроки.",
    },
    {
        id: "content",
        q: "Что нужно от меня для старта?",
        a: "Логотип (если есть), примеры сайтов, которые нравятся, список услуг/тарифов, расписание ближайших поставок, контакты, домен (если уже куплен), документы (политика конфиденциальности, договор-оферта, условия и положения). Остальное поможем упаковать: тексты, структура, блоки и офферы.",
    },
    {
        id: "support",
        q: "Что после запуска — вы поддерживаете сайт?",
        a: "Да. У нас есть ежемесячная подписка: за вами закрепляется менеджер, который всегда на связи. В подписку входят мелкие правки, новые блоки/страницы, улучшение конверсии и регулярные обновления. Также передадим инструкции и доступы, чтобы вы могли управлять контентом.",
    },
    {
        id: "mobile",
        q: "Сайт будет нормально работать на телефоне?",
        a: "Да, делаем адаптив. Проверяем ключевые сценарии (заявка, запись, просмотр информации) на мобильных устройствах перед публикацией.",
    },
];

interface SiteProps {
    onOpenModal: (type: "order" | "consult") => void;
}

const Site: React.FC<SiteProps> = ({onOpenModal}) => {
    const [activeSiteSlideIndex, setActiveSiteSlideIndex] = useState<number>(0);
    const [activeCrmSlideIndex, setActiveCrmSlideIndex] = useState<number>(0);
    const [openFaqId, setOpenFaqId] = useState<string | null>(faqItems[0].id);

    const toggleFaq = (id: string) => {
        setOpenFaqId((prev) => (prev === id ? null : id));
    };

    const handleFeatureClick = (key: SlideKey) => {
        const index = slidesSite.findIndex((s) => s.key === key);
        if (index !== -1) {
            setActiveSiteSlideIndex(index);
        }
    };

    const handleFeatureClickCrm = (key: SlideKey) => {
        const index = slidesCrm.findIndex((s) => s.key === key);
        if (index !== -1) {
            setActiveCrmSlideIndex(index);
        }
    };

    return (
        <>
            {/* Hero — крупный блок */}
            <section className="hero-section">
                <div className="hero-text">
                    <p className="hero-tag">Сайт</p>
                    <h1>Сайт для вашего фулфилмента</h1>
                    <p className="hero-subtitle">
                        Продающая главная, удобный личный кабинет и онлайн-запись
                        на поставки — всё в одном сайте.
                    </p>
                    <div className="hero-actions">
                        <button
                            className="hero-primary-btn"
                            onClick={() => onOpenModal("order")}
                        >
                            Заказать сайт
                        </button>
                        <button
                            className="hero-secondary-link"
                            type="button"
                            onClick={() => onOpenModal("consult")}
                        >
                            <span className="link-text">Получить консультацию</span>
                        </button>
                    </div>
                </div>
                <div className="hero-accent-card">
                    <p className="hero-accent-title">
                        Мы говорим с фулфилментом на одном языке
                    </p>
                    <p className="hero-accent-text">
                        Расписание поставок, заказы, слоты и коробки — мы умеем
                        превращать операционный хаос в аккуратный, понятный интерфейс
                        для клиентов.
                    </p>
                </div>
            </section>
            {/* Problems */}
            <section className="problems-section">
                <div className="problems-header">
                    <p className="section-kicker">Скажите, у вас тоже так?</p>
                    <h2>Эти проблемы тормозят ваш бизнес</h2>
                    <p className="section-subtitle">
                        Делаем сайт, который ускоряет оформление поставок и наводит порядок в процессах: меньше ручной
                        работы, меньше путаницы, больше повторных клиентов.
                    </p>
                </div>

                <div className="problems-grid">
                    <div className="problem-card">
                        <h3>Хаос в коммуникациях</h3>
                        <ul>
                            <li>Клиенты пишут в мессенджеры вместо оформления заявки</li>
                            <li>Постоянные уточнения “куда, когда и что привезти”</li>
                            <li>Менеджер тратит время на одно и то же</li>
                        </ul>
                    </div>

                    <div className="problem-card">
                        <h3>Слоты и расписание “на коленке”</h3>
                        <ul>
                            <li>Запись ведётся в таблицах/чатах — легко ошибиться</li>
                            <li>Пересечения поставок и накладки по времени</li>
                            <li>Нет прозрачности для клиента</li>
                        </ul>
                    </div>

                    <div className="problem-card">
                        <h3>Заказы без структуры</h3>
                        <ul>
                            <li>Сложно быстро понять статус и состав заказа</li>
                            <li>Нет единого места, где хранится история взаимодействий</li>
                            <li>Ошибки при изменениях “в последний момент”</li>
                        </ul>
                    </div>

                    <div className="problem-card">
                        <h3>Деньги проходят мимо</h3>
                        <ul>
                            <li>Нет удобной онлайн-оплаты</li>
                            <li>Сложно “приземлить” клиента из рекламы</li>
                            <li>Меньше конверсия в заявку и повторные поставки</li>
                        </ul>
                    </div>

                    <div className="problem-card">
                        <h3>Нет единого “окна” для клиента</h3>
                        <ul>
                            <li>Клиент не понимает, что делать дальше и где смотреть статусы</li>
                            <li>Документы, инструкции и ссылки разбросаны по чатам</li>
                            <li>Менеджер постоянно отвечает на повторяющиеся вопросы</li>
                        </ul>
                    </div>

                    <div className="problem-card">
                        <h3>Нет нормального личного кабинета</h3>
                        <ul>
                            <li>Клиент не видит статусы, документы и историю</li>
                            <li>Нужно постоянно “пинать” менеджера</li>
                            <li>Падает доверие и лояльность</li>
                        </ul>
                    </div>
                </div>

                <div className="problems-cta">
                    <div className="problems-cta-text">
                        <p className="problems-cta-title">Знакомо?</p>
                        <p className="problems-cta-subtitle">
                            Эти проблемы мешают вашему бизнесу зарабатывать больше.
                        </p>
                    </div>

                    <button
                        className="hero-primary-btn"
                        onClick={() => onOpenModal("consult")}
                    >
                        Записаться на бесплатную консультацию
                    </button>
                </div>
            </section>

            {/* Laptop + Features */}
            <section className="features-section">
                <div className="features-left">
                    <div className="laptop-mockup">
                        <div className="laptop-top">
                            <span className="dot"/>
                            <span className="dot"/>
                            <span className="dot"/>
                        </div>
                        <div className="laptop-screen">
                            <div
                                className="slides-wrapper"
                                style={{
                                    transform: `translateX(-${activeSiteSlideIndex * 100}%)`,
                                }}
                            >
                                {slidesSite.map((slide) => (
                                    <div className="slide" key={slide.id}>
                                        <div className="slide-image-wrapper slide-image-wrapper--wide">
                                            <img
                                                src={slide.image}
                                                alt={slide.title}
                                                className="slide-image"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="laptop-bottom"/>
                    </div>
                </div>

                <div className="features-right">
                    <h2>Что будет в вашем сайте?</h2>
                    <ul className="feature-list">
                        {featuresSite.map((f, idx) => {
                            const slideIndex = slidesSite.findIndex((s) => s.key === f.key);
                            const isActive = slideIndex === activeSiteSlideIndex;
                            return (
                                <li key={f.key}>
                                    <button
                                        type="button"
                                        className={
                                            "feature-item" +
                                            (isActive ? " feature-item--active" : "")
                                        }
                                        onClick={() => handleFeatureClick(f.key)}
                                    >
                                        <span className="feature-bullet"></span>
                                        <span className="feature-label">{f.label}</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </section>

            {/* Laptop + Features */}
            <section className="features-section features-section--reverse" style={{marginTop: 80}}>
                <div className="features-right">
                    <h2>Что будет в вашей CRM?</h2>
                    <ul className="feature-list">
                        {featuresCrm.map((f, idx) => {
                            const slideIndex = slidesCrm.findIndex((s) => s.key === f.key);
                            const isActive = slideIndex === activeCrmSlideIndex;
                            return (
                                <li key={f.key}>
                                    <button
                                        type="button"
                                        className={
                                            "feature-item" +
                                            (isActive ? " feature-item--active" : "")
                                        }
                                        onClick={() => handleFeatureClickCrm(f.key)}
                                    >
                                        <span className="feature-bullet"></span>
                                        <span className="feature-label">{f.label}</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="features-left">
                    <div className="laptop-mockup">
                        <div className="laptop-top">
                            <span className="dot" />
                            <span className="dot" />
                            <span className="dot" />
                        </div>
                        <div className="laptop-screen">
                            <div
                                className="slides-wrapper"
                                style={{
                                    transform: `translateX(-${activeCrmSlideIndex * 100}%)`,
                                }}
                            >
                                {slidesCrm.map((slide) => (
                                    <div className="slide" key={slide.id}>
                                        <div className="slide-image-wrapper slide-image-wrapper--wide">
                                            <img
                                                src={slide.image}
                                                alt={slide.title}
                                                className="slide-image"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="laptop-bottom" />
                    </div>
                </div>
            </section>

            {/* 7 days integration */}
            <section className="timeline-section">
                <div className="timeline-header">
                    <p className="section-kicker">Без затяжных согласований</p>
                    <h2>Интеграция сайта за 7 дней</h2>
                    <p className="section-subtitle">
                        Понятный процесс: созвон → разработка → тестирование и запуск.
                    </p>
                </div>

                <div className="timeline-grid">
                    <div className="timeline-card">
                        <div className="timeline-top">
                            <span className="timeline-badge">День 1</span>
                            <h3>Демо-консультация</h3>
                        </div>
                        <p className="timeline-lead">Zoom-звонок, где:</p>
                        <ul>
                            <li>покажем демо и лучшие практики для фулфилмента</li>
                            <li>зафиксируем задачи: заявки, слоты, ЛК, оплата, этикетки</li>
                            <li>соберём контент и структуру страниц</li>
                            <li>согласуем стиль и “тон” сайта</li>
                        </ul>
                    </div>

                    <div className="timeline-card">
                        <div className="timeline-top">
                            <span className="timeline-badge">Дни 2–5</span>
                            <h3>Разработка сайта (3–5 дней)</h3>
                        </div>
                        <ul>
                            <li>дизайн/верстка под ваш бренд</li>
                            <li>сборка основных блоков и страниц</li>
                            <li>подключение записи на поставки и базовой логики</li>
                            <li>подготовка к интеграциям (если нужно)</li>
                        </ul>
                    </div>

                    <div className="timeline-card">
                        <div className="timeline-top">
                            <span className="timeline-badge">До 7 дней</span>
                            <h3>Тестирование и запуск</h3>
                        </div>
                        <ul>
                            <li>проверка на мобилках и десктопе</li>
                            <li>прогон сценариев: заявка / запись / оплата (если включена)</li>
                            <li>подключение домена, аналитики, базового SEO</li>
                            <li>финальные правки и публикация</li>
                        </ul>
                    </div>
                </div>

                <div className="timeline-footer">
                    <button
                        className="hero-secondary-link"
                        type="button"
                        onClick={() => onOpenModal("consult")}
                    >
                        <span className="link-text">Хочу пройти демо-консультацию</span>
                    </button>
                </div>
            </section>

            <section className="faq-section" id="faq">
                <div className="faq-header">
                    <p className="section-kicker">FAQ</p>
                    <h2>Частые вопросы</h2>
                    <p className="section-subtitle">
                        Собрали ответы на то, что обычно спрашивают перед стартом.
                    </p>
                </div>

                <div className="faq-list">
                    {faqItems.map((item) => {
                        const isOpen = openFaqId === item.id;
                        return (
                            <div
                                key={item.id}
                                className={"faq-item" + (isOpen ? " faq-item--open" : "")}
                            >
                                <button
                                    type="button"
                                    className="faq-question"
                                    onClick={() => toggleFaq(item.id)}
                                    aria-expanded={isOpen}
                                >
                                    <span className="faq-q-text">{item.q}</span>
                                    <span className={"faq-icon" + (isOpen ? " faq-icon--open" : "")}>
              +
            </span>
                                </button>

                                <div
                                    className="faq-answer-wrap"
                                    style={{maxHeight: isOpen ? 240 : 0}}
                                >
                                    <div className="faq-answer">{item.a}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="faq-cta">
                    <div>
                        <p className="faq-cta-title">Остались вопросы?</p>
                        <p className="faq-cta-subtitle">
                            Разберём вашу ситуацию и подскажем лучший вариант под ваш процесс.
                        </p>
                    </div>

                    <button
                        className="hero-primary-btn"
                        onClick={() => onOpenModal("consult")}
                    >
                        Записаться на консультацию
                    </button>
                </div>
            </section>
        </>
    );
};

export default Site;
